module.exports = __webpack_public_path__ + "img/materialY.3e0100cf.png";